import React,{useState,useEffect,useCallback} from 'react';
import { useHistory,useParams,useLocation} from "react-router-dom";
import axios from "../../utils/axios";
import Swal from 'sweetalert2'
import Moment from 'moment';
import { getToken, getUser } from '../../utils/Common';
import { setUserSession } from '../../utils/Common';
import DataTable from 'react-data-table-component';
import HEAD from '../../component/header'
import SIDE from '../../component/navbar'

function Supplier() {

const token = getToken();
const headers = { Authorization: `Bearer ${token}`,'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' };
const history = useHistory();
const FileDownload = require('js-file-download');
// Session
const userData = getUser() || {};
const udeptID = userData.dept_id;
const hcode = userData.hotel_id;

// Var
const [listSupplier, setListSupplier] = useState([]);

const downloadPurchaseProposalWaiting = () => {
    axios
        .get(`/api/generate/excel/report/waiting/proposal/${hcode}/${udeptID}`,
          {responseType: 'blob'},
          {headers:headers}
        )
        .then(function (response) {
        //   
          FileDownload(response.data, 'purchase_proposal.xlsx');
        })
        .catch(function (error) {

        });
}

const columns = [
    {
        name: 'Company Name',
        wrap: true,
        cell: (row) => (
            <div>
            <b>{row.companytype}. {row.companyname}</b> 
            </div>
        ),
    },
    {
        name: 'Email',
        wrap:true,
        cell: (row) => row.email,
    },
    {
        name: 'Phone',
        cell: (row) => row.telephoneno,
    },
    {
        name: ' Bank ',
        cell: (row) => (
            <div>
            <b>{row.bankname}:{row.bankaccountno}</b> 
            </div>
        ),
    },
    {
        name: 'Product Category',
        wrap:true,
        cell: (row) => (
            <>
                <i>{row.productcategory}</i>
            </>
        )
    },
    {
        name: '',
        width: '50px',
        cell: (row) => (
            <div onClick={()=>history.push(`/detail/supplier/${row.idSupplier}`)}>
                <i class="bi bi-search"></i>
            </div>
        ),
    },
    
];

// Search 
const [filtertext, setFilterText] = useState('');
const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

const filteredItems = listSupplier.filter(
    search => (Object.values(search).join('').toLowerCase().includes(filtertext.toLowerCase()))
);

const handleClear = () => {
    if (filtertext) {
    setResetPaginationToggle(!resetPaginationToggle);
    setFilterText('');
    }
};

const getSupplier =  useCallback (() => {

    axios
    .get(`/api/list/suppliers`,{headers:headers})
    .then(function (response) {
        // 
        setListSupplier(response.data);
    })
    .catch(function (error) {

    });

},[udeptID,hcode,headers]);

useEffect(() => {
    getSupplier(); 
}, []);


return (
   <>
   <HEAD />
   <SIDE />

   <main id="main" className="main">

    <div className="pagetitle">
      <h1>Supplier & Vendor</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a>Home</a></li>
          <li className="breadcrumb-item ">List</li>
          <li className="breadcrumb-item active">Supplier</li>
        </ol>
      </nav>
    </div>

    <section>

      <div className='row'>
        <div className='col-12'>
        <div className="card">
            <div className="card-body">
              <div className="card-title">
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>getSupplier()}><i className="bi bi-arrow-clockwise"></i></button>
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>downloadPurchaseProposalWaiting()}><i className="bi bi-printer"></i></button>
                <button type="button" className="btn btn-sm btn-outline-primary" style={{marginRight:"1%"}} onClick={()=>history.push('/add/supplier')}><i className="bi bi-plus"></i></button>
              </div>

              <div className='row p-2 mb-2'>
               
                    <div className="col-12">
                        <input type="text" className="form-control" placeholder="Search" onChange={e => setFilterText(e.target.value)} onClear={()=>handleClear} filtertext={filtertext}/>
                    </div>

      
              </div>

              <div className='row'>
              <DataTable
                        columns={columns}
                        data={filteredItems}
                        fixedHeader
                        fixedHeaderScrollHeight="440px"
                        pagination
                        // expandableRows
                        // expandableRowsComponent={ExpandedComponent}
                    />
              </div>
              
            </div>
          </div>
        </div>
      </div>

    </section>

    </main>
   
   </>
  )
}

export default Supplier